import React, { createContext, useContext, useEffect } from 'react'
import { useFetchSingle } from '../hooks/useFetchSingle'
import { PluginData } from '../types/PluginData'
import i18n from '../i18n'
import { ApiRoutes } from '../services/ApiService'

type PluginContextType = {
    plugin: PluginData | null
}

const PluginContext = createContext<PluginContextType | undefined>(undefined)

type PluginContextProps = {
    children: React.ReactNode | React.ReactNode[]
}

export const PluginContextProvider = ({
    children,
}: PluginContextProps): JSX.Element => {
    const { data: plugin, fetch: fetchPlugin } = useFetchSingle<PluginData>(
        ApiRoutes.PLUGIN
    )

    useEffect(() => {
        fetchPlugin(
            window.location.href.includes('admin') ? 'admin' : 'frontend'
        )
    }, [fetchPlugin])

    useEffect(() => {
        if (!plugin) return
        i18n.changeLanguage(plugin.language.i18n).then(() => {
            localStorage.setItem('zr_customizer_language', plugin.language.i18n)
        })
    }, [plugin])

    return (
        <PluginContext.Provider
            value={{
                plugin,
            }}
        >
            {children}
        </PluginContext.Provider>
    )
}

export const usePluginContext = () => {
    const data = useContext(PluginContext)

    if (data === undefined) {
        throw new Error(
            'usePluginContext must used within PluginContextProvider'
        )
    }

    return data
}
